/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

// import { User } from 'firebase/auth';
import { User } from 'firebase/auth';
import AppConfig from '../../AppConfig';
import { firebaseErrorLogger } from '../app/firebaseErrorLogger';
import FrontAPI from '../app/FrontAPI'; 
import _set from "lodash/set";
import { DataType, IFormStateEntidades } from '../IFormularios';
import { ITablePaginacao, Order } from '../../componentes/tabelas/ITabelas';
import { IPropsFilterObj } from '../../componentes/tabelas/TableFilter';
import { isUndefined } from 'lodash';

interface UploadResult {
    filename: string;
    success: boolean;
    error?: string;
}

export interface IGeneros
{
    idGenero?: number|undefined
    nome?: string
    idQuemCadastrou?: string
    idQuemAlterou?: null,
    dataCadastro?: string
    dataAlteracao?: string
}

export interface IProdutoras
{
    idProdutora?: number
    nome?: string
    idQuemCadastrou?: string
    idQuemAlterou?: string|null
    dataCadastro?: string
    dataAlteracao?: string|null
}
export interface IEntidadesData
{
    titulo?: string,
    nome?: string,
    idQuemCadastrou?: string,
    idQuemCadastrouDisplayName?: string,
    idQuemAlterou?: string|null,
    idQuemAlterouDisplayName?: string|null,
    series?: string,
    idProdutora?: number
    dataCadastro?: string
    dataAlteracao?: string|null
    bucket?: string
    diretorio?: string
    idRepositorio?: number
    idGenero?: number|undefined
    rows?: IEntidadesData[]
    generos?: IGeneros[]
    produtoras?: []
    programas?: number[]
    idSerie?: number
    dataAlerta?: string
    tipoSerie?: number
    anoProducao?: string
    anoProducaoInicial?: string
    anoProducaoFinal?: string
    apresentador?: string
    areaInteresse?: string
    classificacaoEtaria?: number|null
    consultoria?: string
    direcao?: string
    edicao?: string,
    elenco?: string,
    fotografia?: string,
    narrador?: string,
    numeroCpbv?: string,
    numeroCrt?: string,
    numeroEpisodios?: number|undefined,
    parceiroInstitucional?: string,
    parceria?: string,
    patrocinador?: string,
    pjur?: string,
    possuiNumeroCrt?: boolean,
    prazoCrtCpb?: string,
    producao?: string,
    roteiro?: string,
    sinopseSerie?: string
    sol?: string,
    titularidade?: string,
    tituloPortugues?: string,
    trilhaOriginal?: string,
    numeroCpb?: string       
}   

export interface IRetornoAjaxEntidades
{
    Data: IEntidadesData
    pager?: ITablePaginacao
    message?: string
    status?: number
}

export default class Entidades_FrontAPI extends FrontAPI
{
    //#region PRODUTORA [LIST, CREATE, UPDATE, DELETE]

        public async produtoraListaAjax(token:string,idProdutora?:number,callbackDataFilter?:IPropsFilterObj,rowsNum?:number,pageNum?:number) : Promise<null|IRetornoAjaxEntidades>
        {
            const url = AppConfig.API.produtora.list;
            const header = {"Authorization" : "Bearer "+token}
            
            try
            {
                let qs = {};

                if(idProdutora)
                    _set(qs, 'idProdutora', idProdutora);
                else
                {
                    if(rowsNum)
                        _set(qs, 'pageSize', rowsNum);
                    
                    if(pageNum)
                        _set(qs, 'pageNum', pageNum);

                    if(callbackDataFilter)            
                        for (const indiceFilter in callbackDataFilter)
                        {
                            if (callbackDataFilter.hasOwnProperty(indiceFilter))
                            {
                                _set(qs, indiceFilter, callbackDataFilter[indiceFilter]);
                            }
                        }   
                }
                    
                const res = await this.httpGet(url, header, qs, undefined)

                if(res.status && (res.status == 200 || res.status == 201))
                {
                    let retorno = res.data;

                    retorno.status = 200;

                    return retorno;
                }
                else
                {
                    let retorno = res.data;

                    retorno.status = 400;

                    return retorno;
                }
            }
            catch(e)
            {
                if(typeof e === "string") {
                    let retorno = {
                        Data: null,
                        status: 400,
                        message: this.traduzirMensagemErro(e),
                    };
                    return retorno;
                }
                return e;
            }
        }
        
        public async produtoraCreateAjax(token:string,data:IFormStateEntidades) : Promise<null|IRetornoAjaxEntidades>
        {
            const url = AppConfig.API.produtora.create;
            const header = {"Authorization" : "Bearer "+token}
            const params = {
                nome: data.nome,
                idQuemCadastrou: data.idQuemCadastrou
            }

            try
            {
                const res = await this.httpPost(url, params, header, undefined);

                if(res.status && (res.status == 200 || res.status == 201))
                {
                    let retorno = res.data;

                    retorno.status = 200;

                    return retorno;
                }
                else
                {
                    let retorno = res.data;

                    retorno.status = 400;

                    return retorno;
                }
            }
            catch(e)
            {
                if(typeof e === "string") {
                    let retorno = {
                        Data: null,
                        status: 400,
                        message: this.traduzirMensagemErro(e),
                    };
                    return retorno;
                }
                return e;
            }
        }

        public async produtoraUpdateAjax(token:string,data:IFormStateEntidades) : Promise<null|IRetornoAjaxEntidades>
        {
            const url = AppConfig.API.produtora.update;
            const header = {"Authorization" : "Bearer "+token}
            const params = {
                idProdutora: data.idProdutora,
                nome: data.nome,
                idQuemAlterou: data.idQuemAlterou
            }

            try
            {
                const res = await this.httpPut(url, params, header);

                if(res.status && (res.status == 200 || res.status == 201))
                {
                    let retorno = res.data;

                    retorno.status = 200;

                    return retorno;
                }
                else
                {
                    let retorno = res.data;

                    retorno.status = 400;

                    return retorno;
                }
            }
            catch(e)
            {
                if(typeof e === "string") {
                    let retorno = {
                        Data: null,
                        status: 400,
                        message: this.traduzirMensagemErro(e),
                    };
                    return retorno;
                }
                return e;
            }
        }

        public async produtoraDeleteAjax(token:string,idProdutora:string) : Promise<undefined|IRetornoAjaxEntidades>
        {
            const url = AppConfig.API.produtora.delete+'?idProdutora='+idProdutora;
            const header = {"Authorization" : "Bearer "+token}

            try
            {
                const res = await this.httpDelete(url, null, header);

                if(res.status && (res.status == 200 || res.status == 201))
                {
                    let retorno = res.data;

                    retorno.status = 200;

                    return retorno;
                }
                else
                {
                    let retorno = res.data;

                    retorno.status = 400;

                    return retorno;
                }
            }
            catch(e)
            {
                if(typeof e === "string") {
                    let retorno = {
                        Data: null,
                        status: 400,
                        message: this.traduzirMensagemErro(e),
                    };
                    return retorno;
                }
                return e;
            }
        }

    //#endregion

    //#region REPOSITORIO [LIST, CREATE, UPDATE, DELETE]

        public async repositorioListaAjax(token:string,idRepositorio?:number,callbackDataFilter?:IPropsFilterObj,rowsNum?:number,pageNum?:number) : Promise<null|IRetornoAjaxEntidades>
        {
            const url = AppConfig.API.repositorio.list;
            const header = {"Authorization" : "Bearer "+token}
            
            try
            {
                let qs = {};

                if(idRepositorio)
                    _set(qs, 'idRepositorio', idRepositorio);
                else
                {
                    if(rowsNum)
                        _set(qs, 'pageSize', rowsNum);
                    
                    if(pageNum)
                        _set(qs, 'pageNum', pageNum);

                    if(callbackDataFilter)            
                        for (const indiceFilter in callbackDataFilter)
                        {
                            if (callbackDataFilter.hasOwnProperty(indiceFilter))
                            {
                                _set(qs, indiceFilter, callbackDataFilter[indiceFilter]);
                            }
                        }   
                }
                    
                const res = await this.httpGet(url, header, qs, undefined)

                if(res.status && (res.status == 200 || res.status == 201))
                {
                    let retorno = res.data;

                    retorno.status = 200;

                    return retorno;
                }
                else
                {
                    let retorno = res.data;

                    retorno.status = 400;

                    return retorno;
                }
            }
            catch(e)
            {
                if(typeof e === "string") {
                    let retorno = {
                        Data: null,
                        status: 400,
                        message: this.traduzirMensagemErro(e),
                    };
                    return retorno;
                }
                return e;
            }
        }
        
		public async repositorioCreateAjax(token:string,data:IFormStateEntidades) : Promise<null|IRetornoAjaxEntidades>
		{
			const url = AppConfig.API.repositorio.create;
			const header = {"Authorization" : "Bearer "+token}
			const params = {
				nome: data.nome,
                bucket: data.bucket,
                diretorio: data.diretorio,
				idQuemCadastrou: data.idQuemCadastrou
			}
			try
			{
				const res = await this.httpPost(url, params, header, undefined);
				if(res.status && (res.status == 200 || res.status == 201))
				{
					let retorno = res.data;
					retorno.status = 200;
					return retorno;
				}
				else
				{
					let retorno = res.data;
					retorno.status = 400;
					return retorno;
				}
			}
			catch(e)
			{
				return e;
			}
		}

		public async repositorioUpdateAjax(token:string,data:IFormStateEntidades) : Promise<null|IRetornoAjaxEntidades>
		{
			const url = AppConfig.API.repositorio.update;
			const header = {"Authorization" : "Bearer "+token}
			const params = {
				idRepositorio: data.idRepositorio,
				nome: data.nome,
                bucket: data.bucket,                
				diretorio: data.diretorio,
				idQuemAlterou: data.idQuemAlterou
			}
			try
			{
				const res = await this.httpPut(url, params, header);
				if(res.status && (res.status == 200 || res.status == 201))
				{
					let retorno = res.data;
					retorno.status = 200;
					return retorno;
				}
				else
				{
					let retorno = res.data;
					retorno.status = 400;
					return retorno;
				}
			}
			catch(e)
			{
				return e;
			}
		}

        public async repositorioDeleteAjax(token:string,idRepositorio:string) : Promise<undefined|IRetornoAjaxEntidades>
        {
            const url = AppConfig.API.repositorio.delete+'?idRepositorio='+idRepositorio;
            const header = {"Authorization" : "Bearer "+token}

            try
            {
                const res = await this.httpDelete(url, null, header);

                if(res.status && (res.status == 200 || res.status == 201))
                {
                    let retorno = res.data;

                    retorno.status = 200;

                    return retorno;
                }
                else
                {
                    let retorno = res.data;

                    retorno.status = 400;

                    return retorno;
                }
            }
            catch(e)
            {                
                return e;
            }
        }
        
    //#endregion

    //#region GÊNERO [LIST, CREATE, UPDATE, DELETE]

        public async generoListaAjax(token:string,idGenero?:number,callbackDataFilter?:IPropsFilterObj,rowsNum?:number,pageNum?:number) : Promise<null|IRetornoAjaxEntidades>
        {
            const url = AppConfig.API.genero.list;
            const header = {"Authorization" : "Bearer "+token}
            
            try
            {
                let qs = {};

                if(idGenero)
                    _set(qs, 'idGenero', idGenero);
                else
                {
                    if(rowsNum)
                        _set(qs, 'pageSize', rowsNum);
                    
                    if(pageNum)
                        _set(qs, 'pageNum', pageNum);

                    if(callbackDataFilter)            
                        for (const indiceFilter in callbackDataFilter)
                        {
                            if (callbackDataFilter.hasOwnProperty(indiceFilter))
                            {
                                _set(qs, indiceFilter, callbackDataFilter[indiceFilter]);
                            }
                        }   
                }
                    
                const res = await this.httpGet(url, header, qs, undefined)

                if(res.status && (res.status == 200 || res.status == 201))
                {
                    let retorno = res.data;

                    retorno.status = 200;

                    return retorno;
                }
                else
                {
                    let retorno = res.data;

                    retorno.status = 400;

                    return retorno;
                }
            }
            catch(e)
            {
                if(typeof e === "string") {
                    let retorno = {
                        Data: null,
                        status: 400,
                        message: this.traduzirMensagemErro(e),
                    };
                    return retorno;
                }
                return e;
            }
        }
        
        public async generoCreateAjax(token:string,data:IFormStateEntidades) : Promise<null|IRetornoAjaxEntidades>
        {
            const url = AppConfig.API.genero.create;
            const header = {"Authorization" : "Bearer "+token}
            const params = {
                nome: data.nome,
                idQuemCadastrou: data.idQuemCadastrou
            }

            try
            {
                const res = await this.httpPost(url, params, header, undefined);

                if(res.status && (res.status == 200 || res.status == 201))
                {
                    let retorno = res.data;

                    retorno.status = 200;

                    return retorno;
                }
                else
                {
                    let retorno = res.data;

                    retorno.status = 400;

                    return retorno;
                }
            }
            catch(e)
            {
                if(typeof e === "string") {
                    let retorno = {
                        Data: null,
                        status: 400,
                        message: this.traduzirMensagemErro(e),
                    };
                    return retorno;
                }
                return e;
            }
        }

        public async generoUpdateAjax(token:string,data:IFormStateEntidades) : Promise<null|IRetornoAjaxEntidades>
        {
            const url = AppConfig.API.genero.update;
            const header = {"Authorization" : "Bearer "+token}
            const params = {
                idGenero: data.idGenero,
                nome: data.nome,
                idQuemAlterou: data.idQuemAlterou
            }

            try
            {
                const res = await this.httpPut(url, params, header);

                if(res.status && (res.status == 200 || res.status == 201))
                {
                    let retorno = res.data;

                    retorno.status = 200;

                    return retorno;
                }
                else
                {
                    let retorno = res.data;

                    retorno.status = 400;

                    return retorno;
                }
            }
            catch(e)
            {
                if(typeof e === "string") {
                    let retorno = {
                        Data: null,
                        status: 400,
                        message: this.traduzirMensagemErro(e),
                    };
                    return retorno;
                }
                return e;
            }
        }

        public async generoDeleteAjax(token:string,idGenero:string) : Promise<undefined|IRetornoAjaxEntidades>
        {
            const url = AppConfig.API.genero.delete+'?idGenero='+idGenero;
            const header = {"Authorization" : "Bearer "+token}

            try
            {
                const res = await this.httpDelete(url, null, header);

                if(res.status && (res.status == 200 || res.status == 201))
                {
                    let retorno = res.data;

                    retorno.status = 200;

                    return retorno;
                }
                else
                {
                    let retorno = res.data;

                    retorno.status = 400;

                    return retorno;
                }
            }
            catch(e)
            {
                if(typeof e === "string") {
                    let retorno = {
                        Data: null,
                        status: 400,
                        message: this.traduzirMensagemErro(e),
                    };
                    return retorno;
                }
                return e;
            }
        }
        
    //#endregion

    //#region SÉRIES [LIST, CREATE, UPDATE, DELETE]

        public async seriesListaAjax(token:string,idSerie?:number,callbackDataFilter?:IPropsFilterObj,rowsNum?:number,pageNum?:number, orderBy?:string, order?:Order, sortParameter?:string) : Promise<null|IRetornoAjaxEntidades>
        {
            const url = AppConfig.API.series.list;
            const header = {"Authorization" : "Bearer "+token}

            try
            {
                let qs = {};

                if(idSerie)
                {
                    _set(qs, 'idSerie', idSerie);
                    _set(qs, 'anexoLink', '1');
                }
               else
                {
                    if(rowsNum)
                        _set(qs, 'pageSize', rowsNum);
                    
                    if(pageNum)
                        _set(qs, 'pageNum', pageNum);

                    if(sortParameter)
                        _set(qs, 'sortParameter', sortParameter);

                    if(order)
                        _set(qs, 'sortDirection', order);

                    if(callbackDataFilter)            
                        for (const indiceFilter in callbackDataFilter)
                        {
                            if (callbackDataFilter.hasOwnProperty(indiceFilter))
                            {
                                _set(qs, indiceFilter, callbackDataFilter[indiceFilter]);
                            }
                        }   
                }

                const res = await this.httpGet(url, header, qs, undefined)

                if(res.status && (res.status == 200 || res.status == 201))
                {
                    let retorno = res.data;

                    retorno.status = 200;

                    return retorno;
                }
                else
                {
                    let retorno = res.data;

                    retorno.status = 400;

                    return retorno;
                }
            }
            catch(e)
            {
                if(typeof e === "string") {
                    let retorno = {
                        Data: null,
                        status: 400,
                        message: this.traduzirMensagemErro(e),
                    };
                    return retorno;
                }
                return e;
            }
        }

        public async seriesCreateAjax(token:string,data:FormData) : Promise<null|IRetornoAjaxEntidades>
        {
            const url = AppConfig.API.series.create;
            const header = {"Authorization" : "Bearer "+token, "Content-Type": "multipart/form-data"}

            try
            {
                const res = await this.httpPost(url, data, header);

                if(res.status && (res.status == 200 || res.status == 201))
                {
                    let retorno = res.data;

                    retorno.status = 200;

                    return retorno;
                }
                else
                {
                    let retorno = res.data;

                    retorno.status = 400;

                    return retorno;
                }
            }
            catch(e)
            {
                if(typeof e === "string") {
                    let retorno = {
                        Data: null,
                        status: 400,
                        message: this.traduzirMensagemErro(e),
                    };
                    return retorno;
                }
                return e;
            }
        }

        public async seriesUpdateAjax(token:string, data:FormData, tipo:DataType) : Promise<null|IRetornoAjaxEntidades>
        {
            if (tipo == DataType.ANEXOS) {
                try {
                    const anexos = JSON.parse(data.get('anexos') as string);
                    const idSerie = JSON.parse(data.get('idSerie') as string);
        
                    const url = `${AppConfig.API.series.list}?idSerie=${idSerie}&anexoLink=1`;
                    const header = {"Authorization" : `Bearer ${token}`};
                    const serieRes = await this.httpGet(url, header);
                    
                    if (!serieRes?.data?.Data) {
                        throw new Error("Não foi possível obter os links de upload");
                    }
        
                    const serie = serieRes.data.Data;
                    const uploadResults: UploadResult[] = [];
                    const errors: string[] = [];

                    for (let i = 0; i < anexos.length; i++) {
                        const fileField = data.get(`anexo.${i}.arquivo`) as File | null;
                        if (fileField) {
                            const anexo = anexos[i];
                            const capitalizedTipo = anexo.tipo
                                .split('-')
                                .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
                                .join('');

                            const linkKey = `linkAnexo${capitalizedTipo}Upload`;
                            const folderInfo = serie[linkKey];
                            let fileUploadUrl = null;
                            let fileTypeParam = null;
                            let signedUrlResponse = null;

                            if (folderInfo?.path && folderInfo?.bucket) {
                                try {
                                    if (AppConfig.Firebase.StorageEmulator) {
                                        const emulatorHost = AppConfig.Firebase.StorageEmulatorHost;
                                        const uploadEmulatorUrl = `http://${emulatorHost}/v0/b/${folderInfo.bucket}/o/${encodeURIComponent(`${folderInfo.path}/${anexo.nome}`)}?uploadType=media`;
                                        const response = await fetch(uploadEmulatorUrl, {
                                            method: 'POST',
                                            body: fileField,
                                            headers: {
                                                'Content-Type': fileField.type || 'application/octet-stream'
                                            }
                                        });
        
                                        if (!response.ok) {
                                            let responseBody = '';
                                            try {
                                                responseBody = await response.text();
                                            } catch (e) {
                                                responseBody = '[Unable to read response body]';
                                            }
                                            firebaseErrorLogger(errors, 'seriesUpdateAjax_anexos_uploadEmulator', {
                                                responseBody: responseBody
                                            });
                                            throw new Error(`HTTP error! status: ${response.status}`);
                                        }
                                    } else {
                                        fileTypeParam = encodeURIComponent(`${fileField.type}` || 'application/octet-stream');
                                        fileUploadUrl = `${AppConfig.API.util.getUploadUrl}?action=getUploadUrl&bucket=${folderInfo.bucket}&fileType=${fileTypeParam}&path=${encodeURIComponent(`${folderInfo.path}/${anexo.nome}`)}`;
                                        signedUrlResponse = await this.httpGet(fileUploadUrl, header);

                                        if (!signedUrlResponse?.data?.Data?.url) {
                                            throw new Error('Failed to get signed URL for upload');
                                        }
    
                                        const response = await fetch(signedUrlResponse?.data?.Data?.url, {
                                            method: 'PUT',
                                            body: fileField,
                                            headers: {
                                                'Content-Type': fileField.type || 'application/octet-stream'
                                            }
                                        });

                                        if (!response.ok) {
                                            let responseBody = '';
                                            try {
                                                responseBody = await response.text();
                                            } catch (e) {
                                                responseBody = '[Unable to read response body]';
                                            }
                                            firebaseErrorLogger(errors, 'seriesUpdateAjax_anexos_signedUrl', {
                                                responseBody: responseBody
                                            });
                                            throw new Error(`HTTP error! status: ${response.status}`);
                                        }
                                    }
        
                                    uploadResults.push({
                                        filename: anexo.nome,
                                        success: true
                                    });
                                } catch (error) {
                                    let additionalData = {
                                        tipo: JSON.stringify(tipo),
                                        idSerie: data.get('idSerie'),
                                        anexo: JSON.stringify(anexo),
                                    } as any;

                                    if(fileUploadUrl) {
                                        additionalData.fileUploadUrl = JSON.stringify(fileUploadUrl);
                                    }

                                    if(fileTypeParam) {
                                        additionalData.fileTypeParam = JSON.stringify(fileTypeParam);
                                    }

                                    firebaseErrorLogger(error, 'seriesUpdateAjax_anexo', additionalData);

                                    const errorMessage = error instanceof Error ? error.message : String(error);
                                    errors.push(`Erro ao fazer upload do arquivo ${anexo.nome}: ${errorMessage}`);
                                    uploadResults.push({
                                        filename: anexo.nome,
                                        success: false,
                                        error: errorMessage
                                    });
                                }
                            } else {
                                errors.push(`Informações de pasta não disponíveis para o arquivo ${anexo.nome} do tipo ${anexo.tipo}`);
                                uploadResults.push({
                                    filename: anexo.nome,
                                    success: false,
                                    error: 'Informações de pasta não disponíveis'
                                });
                            }
                        }
                    }
        
                    if (errors.length > 0) {
                        firebaseErrorLogger(errors, 'seriesUpdateAjax_anexos', {
                            tipo: JSON.stringify(tipo),
                            idSerie: data.get('idSerie'),
                            errors: JSON.stringify(errors)
                        });

                        throw new Error(`Erros durante o upload:\n${errors.join('\n')}`);
                    }

                    // Save the anexo metadata
                    const metadataUrl = AppConfig.API.anexos.serie;
                    const metadataHeader = {"Authorization" : `Bearer ${token}`, "Content-Type": "multipart/form-data"};
                    const metadataBody = {
                        idSerie,
                        anexos: anexos.map((anexo: any) => ({
                            ...anexo,
                            uploadStatus: uploadResults.find(r => r.filename === anexo.nome)?.success ? 'success' : undefined
                        }))
                    };

                    const metadataRes = await this.httpPost(metadataUrl, metadataBody, metadataHeader);
        
                    if (metadataRes.status === 200 || metadataRes.status === 201) {
                        return {
                            Data: null,
                            status: 200,
                            message: uploadResults.every(r => r.success) 
                                ? "Anexos atualizados com sucesso."
                                : `Alguns anexos foram atualizados com sucesso, mas houve ${errors.length} erro(s)`
                        };
                    } else {
                        throw new Error("Erro ao salvar metadados dos anexos");
                    }
        
                } catch(error) {
                    const errorMessage = error instanceof Error ? error.message : String(error);
                    if(typeof errorMessage === "string") {
                        return {
                            Data: null,
                            status: 400,
                            message: this.traduzirMensagemErro(errorMessage),
                        };
                    }
                    return error as IRetornoAjaxEntidades;
                }
            }

            const url = AppConfig.API.series.update;
            const header = {"Authorization" : "Bearer "+token, "Content-Type": "multipart/form-data"}

            try {
                const res = tipo == DataType.SERIE ? await this.httpPut(url, data, header) : await this.httpPost(url, data, header);

                if(res.status && (res.status == 200 || res.status == 201)) {
                    let retorno = res.data;
                    retorno.status = 200;
                    return retorno;
                } else {
                    let retorno = res.data;
                    retorno.status = 400;
                    return retorno;
                }
            } catch(error) {
                const errorMessage = error instanceof Error ? error.message : String(error);
                if(typeof errorMessage === "string") {
                    return {
                        Data: null,
                        status: 400,
                        message: this.traduzirMensagemErro(errorMessage),
                    };
                }
                return error as IRetornoAjaxEntidades;
            }
        }

        public async seriesDeleteAjax(token:string,idSerie:string) : Promise<undefined|IRetornoAjaxEntidades>
        {
            const url = AppConfig.API.series.delete+'?idSerie='+idSerie;
            const header = {"Authorization" : "Bearer "+token}

            try
            {
                const res = await this.httpDelete(url, null, header);

                if(res.status && (res.status == 200 || res.status == 201))
                {
                    let retorno = res.data;

                    retorno.status = 200;

                    return retorno;
                }
                else
                {
                    let retorno = res.data;

                    retorno.status = 400;

                    return retorno;
                }
            }
            catch(e)
            {
                if(typeof e === "string") {
                    let retorno = {
                        Data: null,
                        status: 400,
                        message: this.traduzirMensagemErro(e),
                    };
                    return retorno;
                }
                return e;
            }
        }

    //#endregion

}